import { render, staticRenderFns } from "./newuserSuccess.vue?vue&type=template&id=387be977&scoped=true&"
import script from "./newuserSuccess.vue?vue&type=script&lang=ts&"
export * from "./newuserSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./newuserSuccess.vue?vue&type=style&index=0&id=387be977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387be977",
  null
  
)

export default component.exports